<!--
 * @Description: 用户名密码登录
 * @Author: l_hc
 * @LastEditors: Do not edit
 * @Date: 2019-07-05 17:21:50
 * @LastEditTime: 2019-08-10 16:23:48
 -->
<template>
  <div>
    <el-form ref="form" :rules="form.rules" :model="form.data">
      <el-form-item prop="username">
        <el-input v-model="form.data.username" placeholder="请输入用户名" @keyup.enter.native="$emit('login')" />
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="form.data.password" type="password" placeholder="请输入密码" @keyup.enter.native="$emit('login')" />
      </el-form-item>
      <el-form-item prop="code">
        <el-row>
          <el-col :span="11">
            <el-input v-model="form.data.code" placeholder="请输入验证码" @keyup.enter.native="$emit('login')" />
          </el-col>
          <el-col :push="1" :span="6">
            <img :src="codeid">
          </el-col>
          <el-col :push="1" :span="6">
            <el-button class="change" type="text" @click="changeCode">看不清，换一张</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { encryption, randomLenNum } from '@/utils/common'
import { codeUrl } from '@/api/common'

export default {
  name: 'PhoneLogin',
  data() {
    return {
      // 图形验证码相关
      code: {
        svgcodeKey: this.getCodeKet(),
        svgcode: codeUrl
      },

      // 表单相关
      form: {
        data: {
          username: '',
          password: '',
          code: ''
        },
        rules: {
          username: [{ required: true, validator: this.$validate('username') }],
          password: [{ required: true, validator: this.$validate('password') }],
          code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
        }
      }
    }
  },
  computed: {
    // 路径拼接
    codeid() {
      return `${this.code.svgcode}?randomStr=${this.code.svgcodeKey}`
    }

  },
  methods: {
    // 更新验证码
    changeCode() {
      this.code.svgcodeKey = this.getCodeKet()
    },
    // 获取codekey
    getCodeKet() {
      return randomLenNum(4, new Date())
    },
    // 校验数据
    validateForm() {
      let flag = null
      this.$refs['form'].validate(valid => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.form.data)) // 深拷贝，防止登陆后回显加密数据
          formData.grant_type = 'password'
          formData.scope = 'server'
          formData.password = encryption({ 'key': 'thanks,pig4cloud', 'value': formData.password })
          formData.randomStr = this.code.svgcodeKey
          flag = formData
        } else {
          flag = false
        }
      })
      return flag
    }
  }
}
</script>
<style lang="scss" scoped>
img{
  display: inheriti;
}
</style>
